import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MailStateService } from '../../services/mail-state.service';

@Component({
  selector: 'app-mail-unsubscribe',
  templateUrl: './mail-unsubscribe.page.html',
  styleUrls: ['./mail-unsubscribe.page.css']
})
export class MailUnsubscribePageComponent implements OnInit {

  constructor(
    private router: Router,
    private mailStateService: MailStateService,
  ) {
    setTimeout(
      () => {
        this.mailStateService.reset();
        this.router.navigate(['']);
      },
      5000);
  }

  ngOnInit() {
  }

}
